<template>
  <div class="flex w-auto flex-wrap gap-3">
    <div v-if="showVisa" class="icon-card flex items-center gap-1.5">
      <VcIcon name="visa" class="flex shrink-0" :width="props.labelWidth" :height="props.labelHeight"></VcIcon>
      <span v-if="props.showTypeName" class="font-medium"> Visa </span>
    </div>
    <div v-if="showMastercard" class="icon-card flex items-center gap-1.5">
      <VcIcon name="mastercard" class="flex shrink-0" :width="props.labelWidth" :height="props.labelHeight"></VcIcon>
      <span v-if="props.showTypeName" class="font-medium"> Mastercard </span>
    </div>
    <div v-if="showAmex" class="icon-card flex items-center gap-1.5">
      <VcIcon name="amex" class="flex shrink-0" :width="props.labelWidth" :height="props.labelHeight"></VcIcon>
      <span v-if="props.showTypeName" class="font-medium"> Amex </span>
    </div>
    <div v-if="showDiscover" class="icon-card flex items-center gap-1.5">
      <VcIcon
        name="discover-creditcard"
        class="flex shrink-0"
        :width="props.labelWidth"
        :height="props.labelHeight"
      ></VcIcon>
      <span v-if="props.showTypeName" class="font-medium"> Discover </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { globals } from "@/core/globals";

interface IProps {
  type?: string;
  showTypeName?: boolean;
  labelWidth?: string;
  labelHeight?: string;
}
const props = withDefaults(defineProps<IProps>(), {
  labelWidth: "23",
  labelHeight: "20",
});

const showAll = computed(
  () =>
    !props.type ||
    (props.type !== "VISA" &&
      props.type !== "MASTERCARD" &&
      props.type !== "AMEX" &&
      props.type !== "DISCOVER" &&
      props.type !== "CARD"),
);
const showVisa = computed(() => props.type === "VISA" || showAll.value);
const showMastercard = computed(() => props.type === "MASTERCARD" || showAll.value);
const showAmex = computed(() => props.type === "AMEX" || (showAll.value && globals.currencyCode === "USD"));
const showDiscover = computed(() => props.type === "DISCOVER" || (showAll.value && globals.currencyCode === "USD"));
</script>
